import * as React from 'react';
import { PaymentInstructionLayout } from '../../component/PaymentInstructionLayout.js';

const Invoice = ()=>{
    return /*#__PURE__*/ React.createElement(PaymentInstructionLayout, {
        info: "checkout.payment.method.invoice.info"
    });
};

export { Invoice };
//# sourceMappingURL=Invoice.js.map
